import React from 'react';
import ClearAllButtonContainer from '../../../clear-all-button-container';
import ItemCountContainer from '../../../item-count-container';
import RailSection from '../../../rail-section';
import LeftHandFacets from '../../../left-hand-facets';
import SortBy from '../../../sort-by';
import BopisBarFragment from '../../../bopis-bar-fragment';
import { useBRRedesign } from '../../../../hooks/br-redesign.hook';
import {
  drawerTopSectionStyles,
  drawerMiddleSectionStyles,
  dashboardSelectContainerStyles,
} from './styles';

const MobileExperience = (appliedFacetsCount: number): JSX.Element[] => {
  const isBRRedesignEnabled = useBRRedesign();

  return [
    <RailSection position="drawer" key="rail-section__filter-details" styles={drawerTopSectionStyles()}>
      <ItemCountContainer />
      { appliedFacetsCount > 0 && <ClearAllButtonContainer />}
    </RailSection>,
    <RailSection position="drawer" key="rail-section__facets" styles={drawerMiddleSectionStyles}>
      <LeftHandFacets />
    </RailSection>,
    <RailSection position="top" key="rail-section__bopis">
      <BopisBarFragment />
    </RailSection>,
    <RailSection position="dashboard" key="rail-section__item-count">
      {!isBRRedesignEnabled && <ItemCountContainer />}
    </RailSection>,
    <RailSection position="dashboard" key="rail-section__sort-by" styles={dashboardSelectContainerStyles}>
      <SortBy />
    </RailSection>
  ];
};

export default MobileExperience;
